import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from '@/i18n';
import { CompareProvider } from '@/context/compare';
import EVENTS from '@/utils/Constants/Events';

const COMPARE_CHECKBOX_CLASS = 'js-product-box-compare';
const COMPARE_REACT_ENTRY_ID = 'js-r-compare-entry';

export const bindCompareCheckboxChange = () => {
  document.addEventListener('change', e => {
    if (e.target.classList.contains(COMPARE_CHECKBOX_CLASS)) {
      DLG.EVE.emit(EVENTS.LISTING.COMPARE.PUSH, {
        ...e.target.dataset,
        push: e.target.checked,
      });
    }
  });
};

export default BrandCompareComponent => {
  const el = document.getElementById(COMPARE_REACT_ENTRY_ID);
  if (!el) return;
  i18n.loadNamespaces('compare', () => {
    const CompareApp = () => (
      <I18nextProvider i18n={i18n}>
        <Suspense fallback={<div />}>
          <CompareProvider>
            <BrandCompareComponent />
          </CompareProvider>
        </Suspense>
      </I18nextProvider>
    );
    ReactDOM.render(<CompareApp />, el);
    bindCompareCheckboxChange();
  });
};
